<template>
  <label :for="id" class="def-input">
    <span class="def-input__label-text">
      <template v-if="required">*</template>{{ text }}
    </span>
    <span class="def-input__input-box" :class="{
    focused
  }">
      <input :id="id" :maxlength="name === 'zip_code' ? 5 : ''" @keypress="name === 'zip_code' ? isNumber($event) : ''"
        :type="type" class="def-input__input" :name="name" :required="required" :value="value"
        @input="updateValue($event.target.value)" @focus="focused = true" @blur="focused = false">
    </span>
    <span v-if="error" class="def-input__error">{{ error }}</span>
    <span v-if="customErr && name === 'zip_code'" class="def-input__error">{{ customErr }}</span>
  </label>
</template>

<script>
const url = 'https://api.zippopotam.us/US/'
export default {
  name: 'DefInputZip',
  $_veeValidate: {
    value() {
      return this.value
    }
  },
  props: {
    id: {
      type: String,
      default: 'input',
      required: true
    },
    text: {
      type: String,
      default: 'Input',
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    value: String,
    error: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      focused: false,
      customErr: ''
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
      if (this.name === 'zip_code' && value.length) {
        this.$http.get(url + value)
          .then(res => {
            if (res.status === 200) {
              this.customErr = ''
              this.$emit('updateCustomErr', this.customErr)
            }
          })
          .catch(() => {
            this.customErr = 'Please fill in a valid US ZIP Code.'
            this.$emit('updateCustomErr', this.customErr)
          })
      }
    },
    isNumber(evt, type) {
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (type) {
        if ((charCode > 31 && (charCode < 44 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      } else {
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      }
    }
  }
}
</script>
